module.exports = __webpack_public_path__ + "static/media/benedict-chan-200x200.6e44fdfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/advisors/images/benedict-chan-200x200.jpg
// module id = 1772
// module chunks = 147